import { useToast } from './contexts/ToastContext'
import { useNavigate } from 'react-router-dom'
import { Form, Input, Button } from 'antd'
import React, { useEffect, useState } from 'react'

const EMAIL_REGEX = /(?:[a-z0-9!#$%&'*+\x2f=?^_`\x7b-\x7d~\x2d]+(?:\.[a-z0-9!#$%&'*+\x2f=?^_`\x7b-\x7d~\x2d]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9\x2d]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9\x2d]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9\x2d]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

export default function Unsubscribe() {
  const [form] = Form.useForm()
  const navigate = useNavigate()
  const { errorToast } = useToast()

  const [buttonDisabled, setButtonDisabled] = useState(true)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)
  const [unsubscribedEmail, setUnsubscribedEmail] = useState(null)

  useEffect(() => {
    const search = new URLSearchParams(window.location.search)
    const email = search.get('email')
    const token = search.get('token')

    if (token) {
      handleUnsubscribe(token)
      window.history.replaceState({}, '', window.location.pathname)
      return
    }

    if (!email) return

    form.setFieldValue('email', email)
    setButtonDisabled(!EMAIL_REGEX.test(email))
    window.history.replaceState({}, '', window.location.pathname)
  }, [form])

  const validateEmail = (_rule, value) => {
    if (EMAIL_REGEX.test(value)) {
      return Promise.resolve()
    } else {
      return Promise.reject('Email address is not valid')
    }
  }

  const handleUnsubscribe = (token = null) => {
    setLoading(true)
    setError(null)

    const body = token ? { token } : { email: form.getFieldValue('email') }

    fetch('/api/v1/unsubscribe', {
      method: 'POST',
      body: JSON.stringify(body),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
    })
      .then(response => {
        if (response.ok) {
          return response.json()
        } else {
          throw response
        }
      })
      .then(body => {
        setUnsubscribedEmail(body.email || form.getFieldValue('email'))
        setLoading(false)
      })
      .catch(fetchError => {
        const message = fetchError.statusText || 'Unable to unsubscribe at this time.'
        if (!token) {
          setError(message)
          errorToast(message)
        }
        setLoading(false)
      })
  }

  return (
    <div className="unsubscribe-page">
      <div className="unsubscribe-card">
        <h1>Unsubscribe</h1>
        {unsubscribedEmail
          ? <>
              <p>{unsubscribedEmail} has been successfully unsubscribed.</p>
              <Button type="primary" onClick={() => navigate('/')}>Return to home page</Button>
            </>
          : <Form
              form={form}
              layout="vertical"
              initialValues={{ email: '' }}
              onFieldsChange={() => setButtonDisabled(!form.getFieldValue('email') || form.getFieldsError().some(field => field.errors.length > 0))}
              requiredMark="optional"
            >
              <Form.Item
                label="Email address"
                name="email"
                rules={[{ required: true }, { validator: validateEmail }]}
              >
                <Input autoFocus placeholder="Email address"/>
              </Form.Item>
              {error && <p className="error">{error}</p>}
              <Button loading={loading} disabled={buttonDisabled} onClick={() => handleUnsubscribe()} type="primary" htmlType="submit">
                Unsubscribe
              </Button>
            </Form>
        }
      </div>
    </div>
  )
}
